import {StatsDataAction, StatsDataState} from './types';
import {MatchDetailCleanup} from '../matchDetail/types';
import {
  MATCHDETAIL_CLEANUP,
  STATS_DATA_BY_EVENT_ID_GET_INVALIDATE,
  STATS_DATA_BY_EVENT_ID_GET_REQUEST,
  STATS_DATA_BY_EVENT_ID_GET_RESPONSE,
} from '../actionTypes';


const initialState: StatsDataState = {
  isFetching: false,
  didInvalidate: false,
};

/**
 * Derives the 'statsData' state by reducing a new one every time an involved action is dispatches.
 * If the action is not involved (meaning it's not related with this state), then the state
 * is not changed.
 * @param state
 * @param action
 */
const statsDataReducer = (state: StatsDataState = initialState, action: StatsDataAction | MatchDetailCleanup): StatsDataState => {
  switch (action.type) {
    case STATS_DATA_BY_EVENT_ID_GET_REQUEST:
      return ({
        ...state,
        isFetching: true,
        error: undefined,
      });
    case STATS_DATA_BY_EVENT_ID_GET_RESPONSE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        data: action.payload.statsData,
      });
    case STATS_DATA_BY_EVENT_ID_GET_INVALIDATE:
      return ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: action.error,
      });
    case MATCHDETAIL_CLEANUP:
      return ({...initialState});
    default:
      return state;
  }
};

export default statsDataReducer;
